import { render, staticRenderFns } from "./EditResume.vue?vue&type=template&id=56cf7119&"
import script from "./EditResume.vue?vue&type=script&lang=js&"
export * from "./EditResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports